module.exports = {
  // --- Config ---
  BaseUrl: process.env.REACT_APP_API_URL || "http://localhost:8080/api",
  ImageUrl: process.env.REACT_APP_IMAGE_URL || "http://localhost:8080",

  // --- Auth ---
  SIGNUP_URL: `/users/register`,
  VERIFY_MOBILE: `/users/verifyphone`,
  CHECK_EMAIL: `/users/emailcheck`,
  VERIFY_EMAIL: `/users/verifyEmail`,
  UPDATE_WORK_INFO: `/users/updateworkinfo`,
  SET_PASSWORD: `/users/createpassword`,
  LOGIN: `/users/login`,
  OTP_LOGIN: `/users/otp_login`,
  VERIFY_LOGIN_OTP: `/users/verifyotp`,
  RESET_PASSWORD: `/users/resetpassword`,
  GENERATE_FORGET_PASSWORD_OTP: `/users/generateOtp`,
  PASSMATCH: `/users/passmatch`,
  REFRESH_JWT_TOKEN: `/users/refresh-jwt-token`,

  // --- User / Profile ---
  UPDATE_USER: `/users`,
  CHANGE_PASSWORD: `/users/changepassword`,
  GET_USER: `/users/user`,
  COMPANY: `/company`,

  // --- Teams & Members ---
  CREATE_TEAM: `/teams`,
  TEAM_LIST: `/teams`,
  TEAM_MEMBERS_LIST: `/users/teammembers`,
  TEAM_MEMBER_DETAILS: `/teams/teamMember`,
  EMERGENCY_CONTACT: `/emergency-contact`,
  ADD_MEMBERS: `/addMembers`,
  IMPORT_MEMBERS: `/importMembers`,
  UPDATE_MEMBER: `/updateMember`,
  DELETE_MEMBER: `/removeMember`,
  ADD_DEPARTMENT: `/departments`,
  DELETE_DOCUMENT: `/teams/teamMember`,

  // --- Locations ---
  LOCATION: `/locations`,
  ADDRESS_BOOK: `/addressbook`,
  USER_LOCATION: `/locations/userlocation`,
  UPLOAD_IMAGE: `/locations/upload/image`,
  DELETE_VOICE_FILE: `/locations/delete-audio`,

  // --- Maps & Live Tracking ---
  MAP_MARKER_TEAM: `/map/marker/list`,
  MAP_ROUTE_LIST: `/map/marker/view-routes`,
  SEND_NOTIFICATION: `/map/send-notification`,
  VIEW_HISTORY: `/map/get-location-history`,

  // --- Location Share (public live-location links) ---
  PUBLIC_LOCATION_SHARE: `/location-share/public`,

  // --- Subscriptions & Payments ---
  SUBSCRIPTION_LIST: `/subscriptions/list`,
  MY_SUBSCRIPTION: `/my-subscriptions/select`,
  PAYMENT_SUCCESS: `/my-subscriptions/payment-success`,
  MY_SUBS_AVAIL: `/my-subscriptions/availableSubscription`,
  RENEW_SUBS: `/my-subscriptions/renewSubscription`,
  MY_SUBS: `/my-subscriptions`,
  REFERAL_SUBSCRIPTION: `/my-subscriptions/referal_subsciption`,
  INVOICE_URL: `/my-subscriptions/invoice`,
  DOWNLOAD_INVOICE: `/invoices/downloadInvoice`,
  CREATE_SUBSCRIPTION: `/my-subscriptions/create-subscription`,
  CANCEL_SUBSCRIPTION: `/my-subscriptions/cancel-subscription`,
  SUBSCRIPTION_STATUS: `/my-subscriptions/subscription-status`,

  // --- Notifications ---
  GET_NOTIFICATIONS: `/notifications/user`,
  UPDATE_NOTIFICATION: `/notifications`,

  // --- Messaging / Chat ---
  GET_USER_GROUPS: `/messages/convo-list`,
  GET_ONE_GROUP: `/messages/conversation-details`,

  // --- Referrals ---
  USER_REFFERALS: `/referrals`,
  UPDATE_REFERALS: `/referrals/update`,

  // --- Holidays ---
  HOLIDAY_LIST: `/holiday/list`,
  MARK_A_HOLIDAY: `/holiday/mark-holiday`,
  VERIFY_HOLIDAY: `/holiday`,

  // --- Reports / Charts ---
  LOCATION_PIECHART: `/piechart/location`,
  ATTENDANCE_PIECHART: `/piechart/attendance`,

  // --- Expenses ---
  EXPENSES: `/expenses`,
  EXPENSE_APPROVALS: `/expenses/approvals`,
  EXPENSE_APPROVALS_COUNT: `/expenses/approvals/count`,

  // --- Misc ---
  LANGUAGE: `/language`,
  CREATE_FEEDBACK: `/feedback/create`,
  CREATE_CONTACTUS: `/contact-us/create`,
};
